import { render } from "./movimientoinventariosrestaurante.vue?vue&type=template&id=6da66f9e&scoped=true"
import script from "./movimientoinventariosrestaurante.vue?vue&type=script&lang=js"
export * from "./movimientoinventariosrestaurante.vue?vue&type=script&lang=js"

import "./movimientoinventariosrestaurante.vue?vue&type=style&index=0&id=6da66f9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da66f9e"]])

export default __exports__